module.exports = __webpack_public_path__ + "static/media/stock-supplier.4a41920d.svg";